import React, { Component } from 'react';
import './Models.css';
import ReactTable from 'react-table';
import { FaTrashO as Trash, FaEdit as Edit, FaQuestionCircleO as Help } from 'react-icons/lib/fa';
import moment from 'moment';
import { t } from 'i18next';
import { connect } from 'react-redux';
import TitleBar from '../../../titleBar/TitleBar';
import CRUDTable from '../../subComponents/CRUDTable/CRUDTableComponent';
import MakeModel from '../../subComponents/makeModel/makeModel';
import Modal from '../../subComponents/modals/Modal';
import NavBar from '../../subComponents/navBar/navBar';
import SplashScreen from '../../subComponents/splashscreen/splashscreen';
import { retrieveModels, deleteModel, setSession } from '../../services/testResultsService';
import { showError } from '../../../../reducer/actions';
import { ANALYTICS_WRITE_ROLES } from '../../../../constants';

class Models extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createModalShow: false,
      deleteModalShow: false,
      getStartedModalShow: false,
      inProgressModalShow: false,
      modelInfo: {
      },
      models: [],
      modelToDelete: '',
      retrainModalShow: false,
      retrainModel: false,
      versionToDelete: '',
    };

    this.openCreateModal = this.openCreateModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openRetrainModal = this.openRetrainModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
  }

  componentDidMount() {
    this.setOEM();
    const { dispatch } = this.props;
    retrieveModels().then((requestData) => {
      this.setState({
        models: requestData.body,
      });
    })
      .catch(error => {
        dispatch(showError({
          status: error,
          statusText: 'retrieving models'
        }));
      });

    if (! localStorage.DontShow) {
      this.setState({
        getStartedModalShow: true,
      });
    }
  }

  setOEM = () => {
    const { session } = this.props;
    setSession(session);
  }

  showHelp = () => {
    this.setState({
      getStartedModalShow: true
    });
  }

  reloadModels = () => {
    retrieveModels().then((requestData) => {
      this.setState({
        models: requestData.body,
      });
    });
  }

  closeModal() {
    this.setState({
      createModalShow: false,
      deleteModalShow: false,
      getStartedModalShow: false,
      inProgressModalShow: false,
      retrainModalShow: false,
      retrainModel: false,
    });
  }

  openCreateModal() {
    // const { dispatch } = this.props;
    // dispatch(showError({status: 'big error', statusText: 'opening model error'}))
    this.setState({
      createModalShow: true,
      retrainModel: false,
    });
  }

  openRetrainModal(modelInfo) {
    if (modelInfo.trainStatus === 'In-Progress') {
      this.setState({
        inProgressModalShow: true,
      });
      return;
    }
    const { retrainModalShow } = this.state;
    this.setState({
      modelInfo,
      retrainModalShow: ! retrainModalShow,
      retrainModel: true,
    });
  }

  checkDeleteParameters(model, version) {
    deleteModel(model, version);
    this.setState({
      modalDeleted: true,
    });
    setTimeout(() => { this.openDeleteModal(model); }, 2000);
    setTimeout(() => {
      this.setState({
        modelDeleted: false,
      });
    }, 2100);
  }

  openDeleteModal(modelInfo) {
    const { modelDeleted, deleteModalShow } = this.state;
    if (modelInfo.trainStatus === 'In-Progress') {
      this.setState({
        inProgressModalShow: true,
      });
      return;
    }
    if (modelDeleted) {
      setTimeout(this.setState({
        deleteModalShow: false,
        modelDeleted: true,
      }), 2000);
    } else {
      this.setState({
        deleteModalShow: ! deleteModalShow,
        modelToDelete: modelInfo.trainModelName,
        versionToDelete: modelInfo.VersionID,
      });
    }
  }

  render() {
    const columns = [{
      accessor: 'trainModelName',
      Header: t('tensorAnalytics.tableHeaders.trainModelName'),
    }, {
      accessor: 'ModelType',
      Header: t('tensorAnalytics.tableHeaders.ModelType'),
    }, {
      accessor: 'trainStatus',
      Header: t('tensorAnalytics.tableHeaders.trainStatus'),
    }, {
      accessor: 'VersionID',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {row.value}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.VersionID'),
      width: 80,
    }, {
      accessor: 'NumOfRun',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {row.value}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.NumOfRun'),
      width: 65,
    }, {
      accessor: 'RangeStart',
      Cell: (row) => {
        const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
        return (
          <div>
            {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
          </div>
        );
      },
      Header: t('tensorAnalytics.tableHeaders.RangeStart'),
    }, {
      accessor: 'RangeEnd',
      Cell: (row) => {
        const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
        return (
          <div>
            {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
          </div>
        );
      },
      Header: t('tensorAnalytics.tableHeaders.RangeEnd'),
    }, {
      accessor: 'LastUpdate',
      Cell: (row) => {
        const date = moment(row.value);
        return (
          <div>
            {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
          </div>
        );
      },
      Header: t('tensorAnalytics.tableHeaders.LastUpdate'),
    }, {
      accessor: 'CustomerNote',
      Header: t('tensorAnalytics.tableHeaders.CustomerNote'),
    },

    ];
    let createModel;
    let createModModal;
    let retrainModel;
    let retrainModModal;
    let splashScreen;
    let splashModal;
    let createModelBtn;
    let inProgressWarning;
    let deleteChildren;

    const {
      createModalShow, deleteModalShow, retrainModalShow, getStartedModalShow, models, modelInfo,
      retrainModel: modelToRetrain,
      modelDeleted, modalDeleted, modelToDelete, versionToDelete, inProgressModalShow,
    } = this.state;
    if (getStartedModalShow) {
      splashScreen = (
        <SplashScreen closeModal={this.closeModal} />
      );
      splashModal = (
        <Modal close={this.closeModal}
          title={t('tensorAnalytics.modelsPage.newToThisApplication')}
          style={{
            width: '95%',
          }}
        >
          {splashScreen}
        </Modal>
      );
    }
    // checking users role for write access
    const { session } = this.props;

    if (ANALYTICS_WRITE_ROLES.includes(session.role)) {
      if (modelToRetrain) {
        retrainModel = (
          <MakeModel closeModal={this.closeModal}
            modelInfo={modelInfo}
            retrainModel={modelToRetrain}
            reloadModels={this.reloadModels}
            session={session}
          />
        );
        retrainModModal = (
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.modelsPage.retrainModelModalTitle')}
            style={{
              width: '77%',
            }}
          >
            {retrainModel}
          </Modal>
        );
      } else {
        createModel = (
          <MakeModel closeModal={this.closeModal}
            modelInfo={modelInfo}
            session={session}
            retrainModel={modelToRetrain}
            reloadModels={this.reloadModels}
          />
        );
        createModModal = (
          <Modal close={this.closeModal}
            title={t('tensorAnalytics.modelsPage.createModelModalTitle')}
          >
            {createModel}
          </Modal>
        );
      }
      deleteChildren = (
        <div>
          <h4 className={modelDeleted ? 'hide' : 'show'}>{t('tensorAnalytics.modelsPage.modelDeleteConfirm')}</h4>
          <h4 className={modelDeleted ? 'show' : 'hide'}>{t('tensorAnalytics.modelsPage.modelDeleteNotification')}</h4>
          <div className="modal-button-group">
            <button className="modal-cancel-button"
              type="button"
              onClick={this.closeModal}
            >
              {t('tensorAnalytics.common.cancel')}
            </button>
            <button className={modalDeleted ? 'hide' : 'modal-delete-button'}
              type="button"
              onClick={() => { this.checkDeleteParameters(modelToDelete, versionToDelete); }}
            >
              {t('tensorAnalytics.common.delete')}
            </button>
          </div>
        </div>
      );
      inProgressWarning = (
        <div className="warning-content">
          <h5>{t('tensorAnalytics.modelsPage.inProgressWarning')}</h5>
        </div>
      );
      createModelBtn = (
        <button className="create-model-btn"
          type="button"
          onClick={this.openCreateModal}
        >
          {t('tensorAnalytics.modelsPage.createModel')}
        </button>
      );
      // adding action column to table for writes
      columns.push(
        {
          Cell: props => (
            <div className="actions-btn-group">
              <Edit size={20}
                onClick={() => { this.openRetrainModal(props.original); }}
              />
              <Trash size={20}
                onClick={() => { this.openDeleteModal(props.original); }}
              />
            </div>
          ),
          Header: t('tensorAnalytics.CRUDTableComponent.actionTableHeader'),
          show: true,
        },
      );
    }

    return (
      <div>
        <div className="models-page">
          <TitleBar title={t('tensorAnalytics.modelsPage.title')}>
            <Help onClick={this.showHelp}
              size={36}
              // className="help-button"
              style={{
                fill: '#669044',
                padding: '5px 7px',
              }}
            />
          </TitleBar>
          {/* <TimeAggregation value={this.props.presistFilters.aggregate_by} /> */}
          <NavBar />
          <div className="models-container">
            <div className="models-content">
              { createModelBtn }

              <CRUDTable data={models}
                columns={columns}
                noDataText={t('tensorAnalytics.modelsPage.noModelsTableHelp')}
                options={{
                  deleteRowFunctionality: false,
                  exportToCSV: false,
                  filterable: true,
                  selectRowsFunctionality: false,
                }}
                showPagination
                SubComponent={(row) => {
                  if (row.original.ModelType !== 'Moving Average') {
                    return (
                      <div style={{
                        padding: '20px 300px 20px 300px',
                      }}
                      >
                        {t('tensorAnalytics.modelsPage.notComeWithValidation', {
                          ...row.original.ModelType
                        })}
                      </div>
                    );
                  }
                  if (row.original.trainStatus !== 'Completed') {
                    return (
                      <div style={{
                        padding: '20px 300px 20px 300px',
                      }}
                      >
                        {'Job is not completed.'}
                      </div>
                    );
                  }
                  const validationArr = [];
                  const validationData = row.original.Validation;
                  const validationColumns = [
                    {
                      accessor: 'title',
                      Header: t('tensorAnalytics.tableHeaders.Validation'),
                      id: t('tensorAnalytics.tableHeaders.Validation'),
                    }
                  ];
                  Object.keys(validationData).forEach((item, index) => {
                    const valObj = {
                    };
                    valObj.title = item;
                    const innerObj = validationData[item];
                    Object.keys(innerObj).forEach((innerItem) => {
                      let metric;
                      metric = innerObj[innerItem];
                      if (Number(metric)) {
                        metric = parseFloat(metric).toFixed(3);
                      }
                      valObj[innerItem] = metric;

                      const newColumn = {
                      };
                      if (innerItem === 'RunTime') {
                        newColumn.minWidth = 200;
                      }
                      if (index === 0) {
                        newColumn.accessor = innerItem;
                        newColumn.Header = innerItem;
                        validationColumns.push(newColumn);
                      }
                    });
                    validationArr.push(valObj);
                  });
                  return (
                    <div style={{
                      padding: '20px 300px 20px 300px',
                    }}
                    >
                      <em>
                        {t('tensorAnalytics.modelsPage.investigateYourModels')}
                      </em>
                      <br />
                      <br />
                      <ReactTable data={validationArr}
                        columns={validationColumns}
                        defaultPageSize={validationArr.length}
                        showPagination={false}
                        noDataText={t('tensorAnalytics.modelsPage.noMetricsToDisplay')}
                        defaultSorted={[{
                          id: 'Validation',
                        }]}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div className={createModalShow ? 'show' : 'hide'}>
              {createModModal}
            </div>
            <div className={retrainModalShow ? 'show' : 'hide'}>
              {retrainModModal}
            </div>
            <div className={deleteModalShow ? 'show' : 'hide'}>
              <Modal close={this.closeModal}
                title={t('tensorAnalytics.common.delete')}
              >
                {deleteChildren}
              </Modal>
            </div>
            <div className={inProgressModalShow ? 'show' : 'hide'}>
              <Modal close={this.closeModal}
                title={t('tensorAnalytics.common.caution')}
                style={{
                  width: '50%',
                }}
              >
                {inProgressWarning}
              </Modal>
            </div>
            <div className={getStartedModalShow ? 'show' : 'hide'}>
              {splashModal}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(Models);
